import { ApolloError, useMutation } from '@apollo/client'

import { LocalFile, MutationSendPlanningReportArgs, PlanningReportInput } from '@types'
import { MUTATION_SEND_PLANNING_REPORT } from '../../libs/apollo/mutations/report.mutation'
import { useCreateFile } from '../file/create-file.hook'

type PlanningReportInputWithoutPlanningFileId = Omit<PlanningReportInput, 'planningFileId'>

export const useSendPlanningObservations = (): {
  sendPlanningReport: (input: PlanningReportInputWithoutPlanningFileId, file: LocalFile) => void
  loading: boolean
  error: ApolloError | undefined
} => {
  const { createFile } = useCreateFile()

  const [sendPlanningReport, { loading, error }] = useMutation<void, MutationSendPlanningReportArgs>(
    MUTATION_SEND_PLANNING_REPORT,
    {
      notifyOnNetworkStatusChange: true,
    },
  )

  const _sendPlanningReport = async (input: PlanningReportInputWithoutPlanningFileId, file: LocalFile) => {
    try {
      const remoteFile = await createFile(file, {
        compress: true,
        useWebWorker: true,
        maxSizeMB: 10,
      })

      if (!remoteFile?.id) return

      await sendPlanningReport({
        variables: {
          input: {
            ...input,
            planningFileId: remoteFile.id,
          },
        },
      })
    } catch (error) {
      console.error(error)
    }
  }

  return { sendPlanningReport: _sendPlanningReport, loading, error }
}
